import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  modalTitle: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.title',
    defaultMessage: 'Sort and Filter',
  },
  sortByHeader: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.sortBySection.header',
    defaultMessage: 'Sort by',
  },
  filterByHeader: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.filterBySection.header',
    defaultMessage: 'Filter by',
  },
  clearAllButtonLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.clearAllButton.label',
    defaultMessage: 'Clear all',
  },
  cancelButtonLabel: {
    id: 'course-authoring.files-and-videos.sort-and-filter.modal.cancelButton.label',
    defaultMessage: 'Cancel',
  },
  sortByNameAscending: {
    id: 'course-authoring..files-and-videos.sort-and-filter.modal.sortByNameAscendingButton.label',
    defaultMessage: 'Name (A-Z)',
  },
  sortByNewest: {
    id: 'course-authoring..files-and-videos.sort-and-filter.modal.sortByNewestButton.label',
    defaultMessage: 'Newest',
  },
  sortBySizeDescending: {
    id: 'course-authoring..files-and-videos.sort-and-filter.modal.sortBySizeDescendingButton.label',
    defaultMessage: 'File size (High to low)',
  },
  sortByNameDescending: {
    id: 'course-authoring..files-and-videos.sort-and-filter.modal.sortByNameDescendingButton.label',
    defaultMessage: 'Name (Z-A)',
  },
  sortByOldest: {
    id: 'course-authoring..files-and-videos.sort-and-filter.modal.sortByOldestButton.label',
    defaultMessage: 'Oldest',
  },
  sortBySizeAscending: {
    id: 'course-authoring..files-and-videos.sort-and-filter.modal.sortBySizeAscendingButton.label',
    defaultMessage: 'File size (Low to high)',
  },
  applySortButton: {
    id: 'course-authoring..files-and-videos.sort-and-filter.modal.applyySortButton.label',
    defaultMessage: 'Apply',
  },
});

export default messages;
